import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { AreaSeriesService, CategoryService, ChartComponent, ColumnSeriesService, IPointEventArgs, LegendService, LineSeriesService, StackingColumnSeriesService, ZoomService } from '@syncfusion/ej2-angular-charts';

import { Chart, LineSeries, DateTime, Legend, Tooltip, ILoadedEventArgs, ChartTheme,Category, ColumnSeries, } from '@syncfusion/ej2-charts';
// import { Browser } from '@syncfusion/ej2-base';


@Component({
  selector: 'app-metics-chart-multi-series-agent-attempts-single',
  templateUrl: './metics-chart-multi-series-agent-attempts-single.component.html',
  styleUrls: ['./metics-chart-multi-series-agent-attempts-single.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService, AreaSeriesService, LegendService, ZoomService, CategoryService, ColumnSeriesService, StackingColumnSeriesService, LineSeriesService],


})
export class MeticsChartMultiSeriesAgentAttemptsSingleComponent implements OnInit {


   // setup as observable?
   @Input() item_id?: any; // impliments on changes.
   @Input() item_data? // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full


  //syncfusion charts
  @ViewChild('chart_single')
  public chart: ChartComponent;
  // public primaryXAxis: Object;

  // public chartData: Object[];
  public chartData: any;

public marker: Object;
public tooltip: Object;
public Chart2_marker: Object;
public Chart2_tooltip: Object;

// public primaryYAxis: Object;
public cornerRadius: Object;
public chartArea: Object;
public animation: Object;
public pointColorMapping: string;


// Chart Staff User Solo
public chartData2: any;
public pointColorMapping2: string = "log_type_colour";
public tooltip2: Object;
public legendSettings2: Object;
  // Define default values
  private readonly DEFAULT_COLOR = "#cccccc";
  private readonly DEFAULT_ICON = "fa fa-question-circle";
 
  public highScoreAnnotation: any[] = [];
  public lowScoreAnnotations: any[] = [];
 
  primaryXAxis_Category = {
    // valueType: 'DateTimeCategory'
    valueType: 'Category',
    // valueType: "Category",
    title: "Attempts Metric",
    visible: true
    // valueType: 'DateTime'
    
  };

  public lineVisibility = {
    benchmark_metric_1: false,
    benchmark_metric_2: false,
    benchmark_metric_3: false,
    benchmark_metric_4: false,
    benchmark_metric_5: false,
    benchmark_metric_6: false,
    benchmark_difference_metric_1: false,
    benchmark_difference_metric_2: false,
    benchmark_difference_metric_3: false,
    benchmark_difference_metric_4: false,
    benchmark_difference_metric_5: false,
    benchmark_difference_metric_6: false,
  };


  metric_global_colour = '#5FDDB3'; // aqua score colour
  metric_global_icon = 'fa fa-clock-o';


  metric_1_colour = '#457EDD'; // blue
  metric_1_icon = 'fa fa-clock-o';
  metric_2_colour = '#000'; //  Pink
  metric_2_icon = 'fa fa-clock-o';
  metric_3_colour = '#A2D369'; // 
  metric_3_icon = 'fa fa-clock-o';
  metric_4_colour = '#FA6F50'; // 
  metric_4_icon = 'fa fa-clock-o';
  metric_5_colour = '#FECF56'; // 
  metric_5_icon = 'fa fa-clock-o';
  metric_6_colour = '#62ADE5'; // sharmans lite blue
  metric_6_icon = 'fa fa-clock-o';
  
  ChartData_M2: any[];
  ChartData_M3: any[];
  ChartData_M4: any[];
  ChartData_M5: any[];
  ChartData_M6: any[];
  ChartData_A: any[];
  mappedAttempts: any[];
  subjectScore: number;
  lineData2: any;

  public marker2: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill: '#fff',
  };




  public marker_M1_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill:  this.metric_1_colour,
  };



  public marker_M2_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill:  this.metric_2_colour,
  };


  public marker_M3_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill:  this.metric_3_colour,
  };

  public marker_M4_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill:  this.metric_4_colour,
  };

  public marker_M5_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill:  this.metric_5_colour,
  };

  public marker_M6_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    fill:  this.metric_6_colour,
  };


  public marker_Benchmark_Score: Object = {
    visible: true,
    width: 20,
    height: 20,
    shape: 'Diamond',
    fill:  this.metric_1_colour,
    opacity: 0.4
  };
  public marker_Benchmark_Score_M2: Object = {
    visible: true,
    width: 20,
    height: 20,
    shape: 'Diamond',
    fill:  this.metric_2_colour,
    opacity: 0.4
  };
  public marker_Benchmark_Score_M3: Object = {
    visible: true,
    width: 20,
    height: 20,
    shape: 'Diamond',
    fill:  this.metric_3_colour,
    opacity: 0.4
  };
  public marker_Benchmark_Score_M4: Object = {
    visible: true,
    width: 20,
    height: 20,
    shape: 'Diamond',
    fill:  this.metric_4_colour,
    opacity: 0.4
  };
  public marker_Benchmark_Score_M5: Object = {
    visible: true,
    width: 20,
    height: 20,
    shape: 'Diamond',
    fill:  this.metric_5_colour,
    opacity: 0.4
  };
  public marker_Benchmark_Score_M6: Object = {
    visible: true,
    width: 20,
    height: 20,
    shape: 'Diamond',
    fill:  this.metric_6_colour,
    opacity: 0.4
  };

  public marker_Benchmark_Score_Global: Object = {
    visible: true,
    width: 30,
    height: 30,
    shape: 'Diamond',
    fill:  this.metric_global_colour,
    opacity: 0.6
  };

  primaryXAxis_Line: {
    title: string; valueType: string; // Use 'Category' to map subject_number directly
    labelIntersectAction: string; // Optional: Rotate labels for readability
    visible: boolean;
  };

  public primaryYAxis: Object = {
    title: 'Values',
    // minimum: -10, // Adjust based on your data range
    // maximum: 20,
    // interval: 5,
  };
  lineData2_M2_Benchmark_Differences: any[];
  zoom: { enableSelectionZooming: boolean; enablePan: boolean; mode: string; enableAnimation: boolean; };
  legend: { visible: boolean; };
  lineData2_M3_Benchmark_Differences: any[];
  lineData2_M4_Benchmark_Differences: any;
  lineData2_M5_Benchmark_Differences: any[];
  lineData2_M6_Benchmark_Differences: any[];
  lineData_Benchmark_Score: any[];
  lineData_Benchmark_Score_M2: any[];
  lineData_Benchmark_Score_M3: any[];
  lineData_Benchmark_Score_M4: any[];
  lineData_Benchmark_Score_M5: any[];
  lineData_Benchmark_Score_M6: any[];
  lineData_Benchmark_Score_Global: any[];


  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService,
   private modalService: BsModalService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   private _mysqlService: MysqlService,

  ) {

    this.tooltip2 = {
      enable: true
  };

    // Legend configuration
    this.legendSettings2 = {
      visible: true,
      position: 'Bottom',
      shape: 'Circle'
    };

   }

  ngOnInit(): void {

    this.zoom = {
      enableSelectionZooming: true,
      enablePan: true,
      mode: 'XY',
      enableAnimation: true
      };
      this.animation = { enable: false};
      this.legend = { visible: true };

  }

  
  ngOnChanges(changes: SimpleChanges) {

    if (changes.item_data) {
      this.item_data = changes.item_data.currentValue;

      // this.ChartData_A = this.getTimelineData(this.item_data)
      this.mappedAttempts = this.mapItemDataToAttempts(this.item_data);
      this.subjectScore = this.getSubjectScore(this.item_data); // Get subject score
      
        // this.chartData2 = this.transformItemData2ToChartData(this.item_data);
      
        // this.ChartData_M2 = this.transformItemData2ToChartData_M2(this.item_data);
        // this.ChartData_M3 = this.transformItemData2ToChartData_M3(this.item_data);
        // this.ChartData_M4 = this.transformItemData2ToChartData_M4(this.item_data);
        // this.ChartData_M5 = this.transformItemData2ToChartData_M5(this.item_data);
        // this.ChartData_M6 = this.transformItemData2ToChartData_M6(this.item_data);
      


      // this.calculateAnnotations();  // Calculate annotations when data updates


                // Prepare the data for the line series

                this.primaryXAxis_Line = {
                  title: 'Subject Number',
                  valueType: 'Category', // Use 'Category' to map subject_number directly
                  labelIntersectAction: 'Rotate45', // Optional: Rotate labels for readability
                  visible: true
              
                };
              
    this.lineData_Benchmark_Score = this.getLineData_Benchmark_Score(this.mappedAttempts);
    this.lineData_Benchmark_Score_M2 = this.getLineData_Benchmark_Score_M2(this.mappedAttempts);
    this.lineData_Benchmark_Score_M3 = this.getLineData_Benchmark_Score_M3(this.mappedAttempts);
    this.lineData_Benchmark_Score_M4 = this.getLineData_Benchmark_Score_M4(this.mappedAttempts);
    this.lineData_Benchmark_Score_M5 = this.getLineData_Benchmark_Score_M5(this.mappedAttempts);
    this.lineData_Benchmark_Score_M6 = this.getLineData_Benchmark_Score_M6(this.mappedAttempts);

    this.lineData_Benchmark_Score_Global = this.getLineData_Benchmark_Score_Global(this.mappedAttempts);

    this.lineData2 = this.getLineData_M1_benchmark_Difference(this.mappedAttempts);
    this.lineData2_M2_Benchmark_Differences = this.getLineData_M2_benchmark_Difference(this.mappedAttempts, 'attempt.benchmark_difference_metric_2');
    this.lineData2_M3_Benchmark_Differences = this.getLineData_M3_benchmark_Difference(this.mappedAttempts);
    this.lineData2_M4_Benchmark_Differences = this.getLineData_M4_benchmark_Difference(this.mappedAttempts);
    this.lineData2_M5_Benchmark_Differences = this.getLineData_M5_benchmark_Difference(this.mappedAttempts);
    this.lineData2_M6_Benchmark_Differences = this.getLineData_M6_benchmark_Difference(this.mappedAttempts);

    


    // this.lineData2 = this.generateLineData(this.mappedAttempts);
    
    
       // Populate lineData with score differences for each user
              //  this.lineData2 = this.item_data
              //  .map(item => ({
              //      x: item.log_type_name,
              //    //  x: 'BM Difference',
              //      y: item.benchmark_difference_metric_1 ?? 0, // Fallback to 0 if missing
              //      color: item.user_colour,
              //      icon: item.user_icon
              //  }))
              //  .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

              //  // Handle cases where lineData is empty by providing a placeholder
              //  if (this.lineData2.length === 0) {
              //  this.lineData2 = [{ x: 'No Data', y: 0 }];
              //  }



    }
  }




// Staff Chart

// Dynamic Line Benchmark Metrics
generateLineData(mappedAttempts: any[], metricKey: string): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }

  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Use subject_number for x-axis
    y: attempt[metricKey] || 0, // Dynamically map to the specified metric key
  }));
}






getLineData_M1_benchmark_Difference(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }

  return mappedAttempts.map(attempt => ({
    xName: 'Benchmark Difference M1',
    x: attempt.subject_number, // Map to subject_number
    // y: attempt.benchmark_difference_metric_1 // Replace with the appropriate metric or value
    y: attempt.benchmark_difference_metric_1 // Replace with the appropriate metric or value
    // y: attempt.score // Replace with the appropriate metric or value
  }));
}

// dynamic
getLineData_M2_benchmark_Difference(mappedAttempts: any[], y_value: any): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }

  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.benchmark_difference_metric_2 // Replace with the appropriate metric or value
    // y: y_value // Replace with the appropriate metric or value

  }));
}

getLineData_M3_benchmark_Difference(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.benchmark_difference_metric_3 // Replace with the appropriate metric or value
  }));
}

getLineData_M4_benchmark_Difference(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.benchmark_difference_metric_4 // Replace with the appropriate metric or value
  }));
}


getLineData_M5_benchmark_Difference(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.benchmark_difference_metric_5 // Replace with the appropriate metric or value
  }));
}

getLineData_M6_benchmark_Difference(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.benchmark_difference_metric_6 // Replace with the appropriate metric or value
  }));
}

getLineData_Benchmark_Score(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_1  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_Global(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_global  // Replace with the appropriate metric or value

  }));
}

getLineData_Benchmark_Score_M2(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_2  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M3(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_3  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M4(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_4  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M5(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_5  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M6(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_6  // Replace with the appropriate metric or value

  }));
}



toggleLineVisibility(metricKey: string): void {
  this.lineVisibility[metricKey] = !this.lineVisibility[metricKey];
}


mapItemDataToAttempts(item_data: any[]): any[] {
  if (!item_data || !Array.isArray(item_data)) {
    console.warn('Invalid item_data:', item_data);
    return [];
  }

  // Find the first agent with a non-empty agent_attempts_array
  const validAgent = item_data.find(agent => Array.isArray(agent.agent_attempts_array) && agent.agent_attempts_array.length > 0);

  if (!validAgent) {
    console.warn('No valid agents with attempts found.');
    return [];
  }

  // Map the valid agent's attempts
  return validAgent.agent_attempts_array.map((attempt, index) => ({
    attempt_number: index + 1, // Attempt sequence number
    metric_1: this.parseMetric(attempt.metric_1),
    metric_2: this.parseMetric(attempt.metric_2),
    metric_3: this.parseMetric(attempt.metric_3),
    metric_4: this.parseMetric(attempt.metric_4),
    metric_5: this.parseMetric(attempt.metric_5),
    metric_6: this.parseMetric(attempt.metric_6),   // formatted dated
    benchmark_metric_1: attempt.benchmark_metric_1, // days
    benchmark_metric_2: attempt.benchmark_metric_2,
    benchmark_metric_3: attempt.benchmark_metric_3,
    benchmark_metric_4: attempt.benchmark_metric_4,
    benchmark_metric_5: attempt.benchmark_metric_5,
    benchmark_metric_6: attempt.benchmark_metric_6,
    benchmark_difference_metric_1: attempt.benchmark_difference_metric_1,
    benchmark_difference_metric_2: attempt.benchmark_difference_metric_2,
    benchmark_difference_metric_3: attempt.benchmark_difference_metric_3,
    benchmark_difference_metric_4: attempt.benchmark_difference_metric_4,
    benchmark_difference_metric_5: attempt.benchmark_difference_metric_5,
    benchmark_difference_metric_6: attempt.benchmark_difference_metric_6,
    score: attempt.score, // Overall score for the attempt
    score_metric_1: attempt.score_metric_1, // Overall score for the attempt
    score_metric_2: attempt.score_metric_2, // Overall score for the attempt
    score_metric_3: attempt.score_metric_3, // Overall score for the attempt
    score_metric_4: attempt.score_metric_4, // Overall score for the attempt
    score_metric_5: attempt.score_metric_5, // Overall score for the attempt
    score_metric_6: attempt.score_metric_6, // Overall score for the attempt
    log_type_name: validAgent.log_type_name, // Agent name
    subject_number: attempt.subject_number,
  }));



  
}


getSubjectScore(item_data: any): number {
  if (!item_data) return 0;
  return item_data.score || 0; // Use the subject's overall score
}



// verticle timeline for events
getTimelineData(data: any): any[] {
  return data.agent_attempts_array.map((attempt, index) => ({
    attempt_number: index + 1,
    metric_value: this.parseMetric(attempt.metric_1),
    benchmark_difference: attempt.benchmark_difference_metric_1,
  }));
}




// Transformation function with default color and icon
transformItemData2ToChartData(data: any): any[] {
  return data.flatMap(user => 
    user.agent_attempts_array.map(log => ({
      // log_type_name: log.name,
      log_type_name: 'metric_1',
      count: this.parseMetric(log.metric_1), // conver to days
          // log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
          // log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: 45, 
      user_icon: user.user_icon,
      // benchmark_duration: this.parseMetric(log.benchmark_metric_1),
      benchmark_duration: -6,
      rating_duration: 99
    }))
  );
}


transformItemData2ToChartData_M2(data: any): any[] {
  return data.flatMap(user => 
    user.agent_attempts_array.map(log => ({
      // log_type_name: log.name,
      log_type_name: 'metric_2',
      count: this.parseMetric(log.metric_2), // conver to days
      // log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      // log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.benchmark_difference_metric_2, 
      user_icon: user.user_icon,
      benchmark_duration: 90,
      // rating_duration: log.score
      rating_duration: 300
    }))
  );
}

transformItemData2ToChartData_M3(data: any): any[] {
  return data.flatMap(user => 
    user.agent_attempts_array.map(log => ({
      // log_type_name: log.name,
      log_type_name: 'metric_3',
      count: this.parseMetric(log.metric_3), // conver to days
      // log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      // log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.benchmark_difference_metric_3, 
      user_icon: user.user_icon,
      benchmark_duration: log.benchmark_metric_3,
      rating_duration: log.score
    }))
  );
}

transformItemData2ToChartData_M4(data: any): any[] {
  return data.flatMap(user => 
    user.agent_attempts_array.map(log => ({
      // log_type_name: log.name,
      log_type_name: 'metric_4',
      count: this.parseMetric(log.metric_4), // conver to days
      // log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      // log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.benchmark_difference_metric_4, 
      user_icon: user.user_icon,
      benchmark_duration: log.benchmark_metric_4,
      rating_duration: log.score
    }))
  );
}

transformItemData2ToChartData_M5(data: any): any[] {
  return data.flatMap(user => 
    user.agent_attempts_array.map(log => ({
      // log_type_name: log.name,
      log_type_name: 'metric_5',
      count: this.parseMetric(log.metric_5), // conver to days
      // log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      // log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.benchmark_difference_metric_5, 
      user_icon: user.user_icon,
      benchmark_duration: log.benchmark_metric_5,
      rating_duration: log.score
    }))
  );
}


transformItemData2ToChartData_M6(data: any): any[] {
  return data.flatMap(user => 
    user.agent_attempts_array.map(log => ({
      // log_type_name: log.name,
      log_type_name: 'metric_6',
      count: this.parseMetric(log.metric_6), // conver to days
      log_type_colour: log.log_type_colour || this.DEFAULT_COLOR, // Default color
      log_type_icon: log.log_type_icon || this.DEFAULT_ICON, // Default icon
      score_difference_duration: log.benchmark_difference_metric_6, 
      user_icon: user.user_icon,
      benchmark_duration: log.benchmark_metric_6,
      rating_duration: log.score
    }))
  );
}


 // Custom tooltip content function
 public getTooltipContent(args: any): string {

  console.log("Tooltip data:", args.point);  // Log point data for debugging

  const icon = args.point.log_type_icon || this.DEFAULT_ICON;
  const xValue = args.point.x;
  const yValue = args.point.y;

  return `<div style="display:flex;align-items:center;">
              <i class="fa ${icon}"></i> 
              ${xValue}: ${yValue} 
          </div>`;
}



public tooltipRender(args: any): void {
  // Access log_type_icon and other properties safely
  const icon = args.point?.log_type_icon || this.DEFAULT_ICON;
  const xValue = args.point?.x;
  const yValue = args.point?.y;

  // Set custom HTML for tooltip
  // args.tooltip.header = '';
  args.tooltip.template = `<div style="display:flex;align-items:center;">
                              <i class="${icon}" style="margin-right:5px;"></i> 
                              ${xValue}: ${yValue}
                          </div>`;
}




calculateAnnotations(): void {
  if (!this.chartData2 || this.chartData2.length === 0) return;

  const sortedData = [...this.chartData2].sort((a, b) => b.score_difference_duration - a.score_difference_duration);

  // Identify top and bottom values
  this.highScoreAnnotation = [sortedData[0]];
  this.lowScoreAnnotations = sortedData.slice(-3);

  console.log("High Score Annotation:", this.highScoreAnnotation);
  console.log("Low Score Annotations:", this.lowScoreAnnotations);
}





// Convert metric strings to days
parseMetric(metric) {
  if (!metric) return 0; // Return 0 if metric is null or undefined
  const matches = metric.match(/\d+/g);
  if (matches) {
      const [days, hours, minutes, seconds] = matches.map(Number);
      return days + hours / 24 + minutes / 1440 + seconds / 86400; // Converts to days
  }
  return 0;
}






}

